import React from 'react';

const PricingFeatureTable = ({ freeColLabel, paidColLabel, freeSummary, rows, footnote }) => (
    <section className="lp-pricing-sec" style={{ paddingTop: 0, background: 'transparent' }}>
        <div className="lp-container" style={{ maxWidth: 1100 }}>
            <h2 className="lp-h2" style={{ textAlign: 'center', margin: '0 auto 36px', maxWidth: 'none' }} data-lp-reveal>What's included</h2>

            <div className="lp-feature-table">
                <div className="lp-ft-head lp-ft-head--feature">Feature</div>
                <div className="lp-ft-head lp-ft-head--free">{freeColLabel}</div>
                <div className="lp-ft-head lp-ft-head--paid">{paidColLabel}</div>

                {rows.map((row, i) => (
                    <React.Fragment key={i}>
                        <div className="lp-ft-cell lp-ft-cell--feature">{row.title}</div>
                        <div className="lp-ft-cell">
                            {row.freeItems
                                ? <ul>{row.freeItems.map((t, j) => <li key={j}>✓ {t}</li>)}</ul>
                                : <span className="lp-ft-dash">—</span>}
                        </div>
                        <div className="lp-ft-cell">
                            {row.paidItems
                                ? <ul>{row.paidItems.map((t, j) => <li key={j}>✓ {t}</li>)}</ul>
                                : <p>{freeSummary}</p>}
                        </div>
                    </React.Fragment>
                ))}
            </div>
            <p className="lp-price-note">{footnote}</p>
        </div>
    </section>
);

export default PricingFeatureTable;
